import { forwardRef, type Ref, type SVGProps } from "react";
const IconWrenchOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16 26.602a.79.79 0 1 1 0-1.582.79.79 0 0 1 0 1.582"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.586 2.066c-.223.084-.437.169-.652.262a8.1 8.1 0 0 0-5.084 7.28 7.75 7.75 0 0 0 3.118 6.1c.685.535 1.44.973 2.246 1.3l-.79 8.357a4.575 4.575 0 1 0 9.149 0l-.79-8.356a9.4 9.4 0 0 0 2.25-1.302 7.75 7.75 0 0 0 3.117-6.1 8.1 8.1 0 0 0-5.083-7.279q-.32-.138-.653-.262a1.02 1.02 0 0 0-1.38.953v5.572a1.02 1.02 0 0 1-1.017 1.017h-2.033a1.02 1.02 0 0 1-1.017-1.017V3.019a1.02 1.02 0 0 0-1.38-.953m5.956 23.38a2.547 2.547 0 0 1-2.541 2.462 2.55 2.55 0 0 1-2.543-2.461l.753-7.869a10 10 0 0 0 3.578 0zM12.42 14.875a8.1 8.1 0 0 0 7.157 0 6 6 0 0 0 3.538-5.266 5.92 5.92 0 0 0-3.048-5.003v3.986a3.06 3.06 0 0 1-3.05 3.05h-2.033a3.06 3.06 0 0 1-3.05-3.05V4.605a5.92 5.92 0 0 0-3.05 5.003 6 6 0 0 0 3.536 5.266"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconWrenchOutlineSVG);
ForwardRef.displayName = "IconWrenchOutline";
export { ForwardRef as IconWrenchOutline };
